import { SVGProps, Ref, forwardRef } from 'react';

export const ArrowDiagonalRightDownOutlinedSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path d="M7 18.2V20h13V7h-1.8v9.927L5.273 4 4 5.273 16.927 18.2z" fill="currentColor" />
            </g>
        </svg>
    )
);
ArrowDiagonalRightDownOutlinedSize24Glyph.displayName = 'ArrowDiagonalRightDownOutlinedSize24Glyph';
